import React from 'react';
import { Link } from 'gatsby';

import Html from 'views/components/html';
import Header from 'views/components/header';
import Body from 'views/components/body';
import Contents from 'views/components/contents';
import Breadcrumb from 'views/components/breadcrumb';
import RightTriangleSquare from 'views/components/right-triangle-square';
import Footer from 'views/components/footer';
import { Background, Heading, Information } from './index.styled';
import title from './assets/title.gif';

const Contact = () => {
  return (
    <>
      <Html title="お問い合わせ" />
      <Header />
      <Body>
        <Contents>
          <Breadcrumb><Link to="/">HOME</Link>　&gt;　お問い合わせ</Breadcrumb>
          <Background>
            <Heading>
              <h1><img src={title} alt="お問い合わせ" /></h1>
            </Heading>
            <Information>
              <h2>当社へのお問い合わせ</h2>
              <p>当社への見積もり依頼やお問い合わせは、以下までお願いいたします。どうぞお気軽にお問い合わせください。</p>
              <table>
                <tbody>
                <tr>
                  <th><RightTriangleSquare />&nbsp;TEL</th>
                  <td>06-6747-1118（代）</td>
                </tr>
                <tr>
                  <th><RightTriangleSquare />&nbsp;FAX</th>
                  <td>06-6747-1188</td>
                </tr>
                <tr>
                  <th><RightTriangleSquare />&nbsp;MAIL</th>
                  <td><a href="mailto:info@nonakass.com">info@nonakass.com</a></td>
                </tr>
                </tbody>
              </table>
            </Information>
          </Background>
        </Contents>
      </Body>
      <Footer />
    </>
  );
};

export default Contact;
